import Logger from '../lib/logger';
import StorageService from '../lib/storage.service';
import { money } from '../lib/util.functions';

class ColorVariantPicker extends HTMLElement {
  name = 'ColorVariantPicker';
  #abortController;
  /* #searchParams; */
  #variants = []; // { quantity: number, price: number, id: string, option: string , otherOption: string, tieredPricing?: string }[]
  #palette = [];
  #paletteItemsByColor = new Map();
  #activePointer = null;
  #zIndex = 1;
  #totalPrice = '0.00';
  get totalPrice() {
    return this.#totalPrice;
  }
  set totalPrice(price) {
    this.#totalPrice = price;
    if (this.totalEl) this.totalEl.dataset.totalPrice = this.#totalPrice;
    if (this.mobileTotalEl) this.mobileTotalEl.dataset.totalPrice = this.#totalPrice;
  }

  constructor() {
    super();
    Logger.info(`${this.name} > constructor`);
    this.headLabelsEl = this.querySelector('[data-labels]');
    this.totalEl = this.querySelector('[data-total-price]');
    this.listEl = this.querySelector('ul');
    this.items = Array.from(this.querySelectorAll('[data-item]'));
    this.addToCartBtn = this.querySelector('[data-add-to-cart-btn]');
    this.mobileAddToCartBtn = document.querySelector('[data-mobile-add-to-cart-btn]');
    this.mobileTotalEl = this.mobileAddToCartBtn?.querySelector('[data-total-price]');
    this.buyNowBtn = this.querySelector('[data-buy-now-btn]');
    /* this.swatchSelect = this.querySelector('select[data-swatch]');
    this.swatchOptions = this.swatchSelect ? Array.from(this.swatchSelect.querySelectorAll('option')) : []; */
    this.colorDivs = this.querySelectorAll('.color-variant-picker__list__item__color');
    this.paletteWidget = this.querySelector('.color-pallete-widget');
    this.paletteDropzone = this.querySelector('.color-pallete-widget__dropzone');
    this.paletteAddToCartBtn = this.querySelector('[data-palette-add-to-cart]');
    this.paletteClearBtn = this.querySelector('[data-palette-clear]');
    this.paletteViewButtons = Array.from(this.querySelectorAll('[data-palette-view]'));
    this.paletteStyle = 'color';
    this.paletteStorageKey = this.dataset.paletteKey || `color-palette-${window.location.pathname}`;
    /* this.#initSearchParams(); */
  }

  connectedCallback() {
    Logger.info(`${this.name} > connectedCallback`);
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    /* window.addEventListener('popstate', (e) => this.#onStateChange(e.state), { signal }); */
    window.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && this.#variants.length) this.#addToCart();
    }, { signal });
    /* this.swatchSelect?.addEventListener('change', () => this.dataset.swatch = this.swatchSelect.value, { signal }); */
    this.cachePaletteItems();
    this.loadPalette();
    this.renderPalette();
    this.setupPaletteVisibility();
    this.setupPaletteDropzone(signal);
    this.setupPaletteViewSwitcher(signal);
    this.items.forEach(li => {
      li.addEventListener('color-table-item:event', (e) => this.#onItemEvent(e), { signal });
      this.setupPaletteSource(li, signal);
    });
    this.addToCartBtn.addEventListener('click', () => this.#addToCart(), { signal });
    this.mobileAddToCartBtn?.addEventListener('click', () => this.#addToCart(), { signal });
    this.buyNowBtn?.addEventListener('click', () => this.#addToCart(true), { signal });
    this.paletteAddToCartBtn?.addEventListener('click', () => this.openPaletteModal(), { signal });
    this.paletteClearBtn?.addEventListener('click', () => this.clearPalette(), { signal });
    window.addEventListener('pointermove', (e) => this.onPalettePointerMove(e), { signal });
    window.addEventListener('pointerup', () => this.stopPalettePointerAction(), { signal });
    window.addEventListener('scroll', () => this.updatePaletteVisibility(), { signal, passive: true });
    window.addEventListener('resize', () => this.updatePaletteVisibility(), { signal });
    this.dataset.show = 'true';
  }

  disconnectedCallback() {
    Logger.info(`${this.name} > disconnectedCallback`);
    this.#abortController.abort();
    this.#abortController = null;
    this.dataset.show = 'false';
  }

  static get observedAttributes() {
    return ['data-swatch'];
  }

  /* attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.name} > attributeChangedCallback:`, name, newValue);
    //
    if (name === 'data-swatch') {
      this.#searchParams.set('swatch', newValue);
      this.#updateState();
    }
  } */

  /* #initSearchParams() {
    Logger.info(`${this.name} > #initSearchParams`);
    this.#searchParams = new URLSearchParams(window.location.search);
    const swatchParamValue = this.#searchParams.get('swatch');
    if (swatchParamValue && this.swatchSelect) {
      this.swatchSelect.value = swatchParamValue;
    } else if (this.swatchSelect?.value) {
      this.#searchParams.set('swatch', this.swatchSelect.value);
    }
    this.#updateState(true);
  } */

  /* #updateState(replace = false) {
    const state = {};
    for (const [key, value] of this.#searchParams.entries()) {
      state[key] = value
    }
    //
    if (replace) {
      history.replaceState(state, '', `${window.location.pathname}?${this.#searchParams.toString()}`);
    } else {
      history.pushState(state, '', `${window.location.pathname}?${this.#searchParams.toString()}`);
    }
    //
    this.#onStateChange(state);
  } */

  /* #onStateChange(state) {
    Logger.info(`${this.name} > #onStateChange`, state);
    //
    if (state.swatch) {
      this.colorDivs.forEach(el => {
        el.dataset.style = state.swatch;
        el.style = el.dataset[`${state.swatch}Style`];
      });
    }
    
  } */

  #onItemEvent(e) {
    Logger.info(`${this.name} > #onItemEvent`, e.detail);
    // find index if variant already exists in array
    const index = this.#variants.findIndex(obj => obj.option === e.detail.option);
    if (index === -1) {
      // add variant
      this.#variants.push({ ...e.detail });
    } else {
      // update variant
      this.#variants[index] = { ...e.detail };
    }
    // remove 0 quantity entries
    this.#variants = this.#variants.filter(obj => obj.quantity > 0);
    Logger.info(`${this.name} > #variants`, this.#variants);
    // set total price
    this.totalPrice = (this.#variants.map(obj => obj.price).reduce((prev, cur) => prev + cur, 0) / 100).toFixed(2);
  }

  cachePaletteItems() {
    this.#paletteItemsByColor.clear();
    this.items.forEach(item => {
      this.#paletteItemsByColor.set(item.dataset.colorOption, {
        color: item.dataset.colorOption,
        swatchStyle: this.getSwatchStyle(item)
      });
    });
  }

  getPaletteSource(color) {
    const item = this.items.find(row => row.dataset.colorOption === color);
    if (!item) return this.#paletteItemsByColor.get(color);

    return {
      color,
      swatchStyle: this.getSwatchStyle(item),
      options: Array.from(item.querySelectorAll('select[data-size] option:not([disabled])')).map(option => ({
        label: option.textContent.trim(),
        value: option.value,
        tierGroup: option.dataset.tierGroup || ''
      }))
    };
  }

  setupPaletteViewSwitcher(signal) {
    if (!this.paletteViewButtons.length) return;

    const hasPattern = this.items.some(item => {
      const swatch = item.querySelector('.color-variant-picker__list__item__color');
      return swatch?.dataset.patternStyle && swatch.dataset.patternStyle !== 'none';
    });

    this.paletteViewButtons.forEach(button => {
      button.disabled = button.dataset.paletteView === 'pattern' && !hasPattern;
      button.addEventListener('click', () => this.setPaletteStyle(button.dataset.paletteView), { signal });
    });
    this.setPaletteStyle('color', false);
  }

  setPaletteStyle(style, shouldRender = true) {
    this.paletteStyle = style === 'pattern' ? 'pattern' : 'color';
    this.paletteViewButtons.forEach(button => {
      const active = button.dataset.paletteView === this.paletteStyle;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (shouldRender) this.renderPalette();
  }

  setupPaletteVisibility() {
    if (!this.paletteWidget) return;

    this.paletteWidget.dataset.active = 'false';
    this.updatePaletteVisibility();
  }

  updatePaletteVisibility() {
    if (!this.paletteWidget) return;

    if (window.matchMedia('(max-width: 959px)').matches) {
      this.paletteWidget.dataset.active = 'false';
      return;
    }

    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const visibleHeight = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
    const targetVisibleHeight = viewportHeight / 2;

    this.paletteWidget.dataset.active = visibleHeight >= targetVisibleHeight ? 'true' : 'false';
  }

  setupPaletteDropzone(signal) {
    if (!this.paletteDropzone) return;

    this.paletteDropzone.addEventListener('dragover', (e) => {
      e.preventDefault();
      this.paletteDropzone.dataset.dragging = 'true';
    }, { signal });
    this.paletteDropzone.addEventListener('dragleave', () => {
      this.paletteDropzone.dataset.dragging = 'false';
    }, { signal });
    this.paletteDropzone.addEventListener('drop', (e) => {
      e.preventDefault();
      this.paletteDropzone.dataset.dragging = 'false';
      const color = e.dataTransfer.getData('text/color-option');
      if (!color) return;
      const rect = this.paletteDropzone.getBoundingClientRect();
      this.addPaletteColor(color, e.clientX - rect.left - 28, e.clientY - rect.top - 28);
    }, { signal });
  }

  setupPaletteSource(item, signal) {
    const swatch = item.querySelector('.color-variant-picker__list__item__color');
    if (!swatch) return;

    swatch.draggable = true;
    swatch.title = `Add ${item.dataset.colorOption} to My Palette`;
    swatch.addEventListener('dragstart', (e) => {
      e.dataTransfer.effectAllowed = 'copy';
      e.dataTransfer.setData('text/color-option', item.dataset.colorOption);
    }, { signal });
    swatch.addEventListener('dblclick', () => this.addPaletteColor(item.dataset.colorOption), { signal });
  }

  getSwatchStyle(item) {
    const swatch = item.querySelector('.color-variant-picker__list__item__color');
    if (!swatch) return '';
    const colorStyle = swatch.dataset.colorStyle === 'none' ? '' : swatch.dataset.colorStyle;
    const patternStyle = swatch.dataset.patternStyle === 'none' ? '' : swatch.dataset.patternStyle;
    return this.paletteStyle === 'pattern'
      ? patternStyle || colorStyle
      : colorStyle || patternStyle;
  }

  loadPalette() {
    const savedPalette = StorageService.get(this.paletteStorageKey);
    this.#palette = Array.isArray(savedPalette)
      ? savedPalette.filter(item => this.#paletteItemsByColor.has(item.color))
      : [];
    this.#zIndex = Math.max(1, ...this.#palette.map(item => item.z || 1));
  }

  savePalette() {
    StorageService.save(this.paletteStorageKey, this.#palette);
    this.paletteWidget?.setAttribute('data-count', this.#palette.length);
    if (this.paletteAddToCartBtn) this.paletteAddToCartBtn.disabled = !this.#palette.length;
  }

  renderPalette() {
    if (!this.paletteDropzone) return;

    this.paletteDropzone.innerHTML = '';
    this.#palette.forEach(item => this.renderPaletteChip(item));
    this.savePalette();
  }

  renderPaletteChip(item) {
    const source = this.getPaletteSource(item.color);
    if (!source) return;

    const chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'color-pallete-widget__chip';
    chip.dataset.color = item.color;
    chip.style.cssText = [
      source.swatchStyle,
      `left: ${item.x}px`,
      `top: ${item.y}px`,
      `width: ${item.size}px`,
      `height: ${item.size}px`,
      `z-index: ${item.z}`
    ].join(';');
    chip.innerHTML = `
      <span class="color-pallete-widget__chip-label">${item.color}</span>
      <span class="color-pallete-widget__chip-remove" aria-hidden="true">&times;</span>
      <span class="color-pallete-widget__chip-resize" aria-hidden="true"></span>
    `;
    chip.setAttribute('aria-label', `${item.color}. Drag to move, resize from the corner, or remove.`);
    chip.addEventListener('pointerdown', (e) => this.startPalettePointerAction(e, item.color, 'move'));
    chip.querySelector('.color-pallete-widget__chip-remove').addEventListener('click', (e) => {
      e.stopPropagation();
      this.removePaletteColor(item.color);
    });
    chip.querySelector('.color-pallete-widget__chip-resize').addEventListener('pointerdown', (e) => this.startPalettePointerAction(e, item.color, 'resize'));
    this.paletteDropzone.appendChild(chip);
  }

  addPaletteColor(color, x = null, y = null) {
    if (!this.#paletteItemsByColor.has(color)) return;

    const existing = this.#palette.find(item => item.color === color);
    const rect = this.paletteDropzone.getBoundingClientRect();
    const defaultX = Math.max(8, Math.min(rect.width - 72, 16 + this.#palette.length * 18));
    const defaultY = Math.max(8, Math.min(rect.height - 72, 16 + this.#palette.length * 18));
    const size = existing?.size || 64;
    const next = {
      color,
      x: this.clamp(x ?? existing?.x ?? defaultX, 0, rect.width - size),
      y: this.clamp(y ?? existing?.y ?? defaultY, 0, rect.height - size),
      size,
      z: ++this.#zIndex
    };

    this.#palette = this.#palette.filter(item => item.color !== color);
    this.#palette.push(next);
    this.renderPalette();
  }

  removePaletteColor(color) {
    this.#palette = this.#palette.filter(item => item.color !== color);
    this.renderPalette();
  }

  clearPalette() {
    this.#palette = [];
    this.renderPalette();
  }

  startPalettePointerAction(e, color, action) {
    if (e.button !== 0) return;
    if (e.target.closest('.color-pallete-widget__chip-remove')) return;
    e.preventDefault();
    e.stopPropagation();
    const item = this.#palette.find(paletteItem => paletteItem.color === color);
    if (!item) return;

    item.z = ++this.#zIndex;
    const rect = this.paletteDropzone.getBoundingClientRect();
    this.#activePointer = {
      action,
      color,
      startX: e.clientX,
      startY: e.clientY,
      startItem: { ...item },
      rect
    };
    e.currentTarget.setPointerCapture?.(e.pointerId);
    this.renderPalette();
  }

  onPalettePointerMove(e) {
    if (!this.#activePointer) return;

    const item = this.#palette.find(paletteItem => paletteItem.color === this.#activePointer.color);
    if (!item) return;

    const deltaX = e.clientX - this.#activePointer.startX;
    const deltaY = e.clientY - this.#activePointer.startY;
    if (this.#activePointer.action === 'resize') {
      const nextSize = this.clamp(this.#activePointer.startItem.size + Math.max(deltaX, deltaY), 40, 144);
      item.size = nextSize;
      item.x = this.clamp(item.x, 0, this.#activePointer.rect.width - nextSize);
      item.y = this.clamp(item.y, 0, this.#activePointer.rect.height - nextSize);
    } else {
      item.x = this.clamp(this.#activePointer.startItem.x + deltaX, 0, this.#activePointer.rect.width - item.size);
      item.y = this.clamp(this.#activePointer.startItem.y + deltaY, 0, this.#activePointer.rect.height - item.size);
    }
    this.updatePaletteChip(item);
  }

  stopPalettePointerAction() {
    if (!this.#activePointer) return;
    this.#activePointer = null;
    this.savePalette();
  }

  updatePaletteChip(item) {
    const chip = Array.from(this.paletteDropzone?.querySelectorAll('[data-color]') || [])
      .find(paletteChip => paletteChip.dataset.color === item.color);
    if (!chip) return;
    chip.style.left = `${item.x}px`;
    chip.style.top = `${item.y}px`;
    chip.style.width = `${item.size}px`;
    chip.style.height = `${item.size}px`;
    chip.style.zIndex = item.z;
  }

  openPaletteModal() {
    if (!this.#palette.length) return;

    const existingModal = this.querySelector('.color-palette-modal');
    existingModal?.remove();

    const modal = document.createElement('div');
    modal.className = 'color-palette-modal';
    modal.innerHTML = `
      <div class="color-palette-modal__overlay" data-palette-modal-close></div>
      <form class="color-palette-modal__dialog">
        <div class="color-palette-modal__header">
          <div class="color-palette-modal__title">Add My Palette</div>
          <button type="button" class="color-palette-modal__close" data-palette-modal-close aria-label="Close">&times;</button>
        </div>
        <div class="color-palette-modal__rows"></div>
        <div class="color-palette-modal__footer">
          <span class="color-palette-modal__total" data-palette-modal-total>${money(0)}</span>
          <button type="submit" class="color-palette-modal__submit">Add Palette to Cart</button>
        </div>
      </form>
    `;

    const rows = modal.querySelector('.color-palette-modal__rows');
    this.#palette
      .slice()
      .sort((a, b) => (a.z || 0) - (b.z || 0))
      .map(item => this.createPaletteModalRow(item))
      .filter(row => row)
      .forEach(row => rows.appendChild(row));

    modal.addEventListener('click', (e) => {
      if (e.target.hasAttribute('data-palette-modal-close')) modal.remove();
    });
    modal.querySelector('form').addEventListener('input', () => this.updatePaletteModalTotal(modal));
    modal.querySelector('form').addEventListener('change', () => this.updatePaletteModalTotal(modal));
    modal.querySelector('form').addEventListener('submit', (e) => this.addPaletteToCart(e, modal));
    this.appendChild(modal);
    this.updatePaletteModalTotal(modal);
  }

  createPaletteModalRow(item) {
    const source = this.getPaletteSource(item.color);
    if (!source?.options?.length) return null;
    const row = document.createElement('div');
    row.className = 'color-palette-modal__row';
    row.dataset.color = item.color;
    row.innerHTML = `
      <div class="color-palette-modal__swatch" style="${source.swatchStyle}"></div>
      <div class="color-palette-modal__name">${item.color}</div>
      <select class="color-palette-modal__select" data-palette-size></select>
      <input class="color-palette-modal__quantity" data-palette-quantity type="number" min="0" step="1" value="0" />
      <div class="color-palette-modal__price" data-palette-row-total>${money(0)}</div>
    `;

    const select = row.querySelector('[data-palette-size]');
    source.options.forEach(option => {
      const optionEl = document.createElement('option');
      optionEl.textContent = option.label;
      optionEl.value = option.value;
      if (option.tierGroup) optionEl.dataset.tierGroup = option.tierGroup;
      select.appendChild(optionEl);
    });

    return row;
  }

  updatePaletteModalTotal(modal) {
    let total = 0;
    modal.querySelectorAll('.color-palette-modal__row').forEach(row => {
      const rowState = this.getPaletteModalRowState(row);
      rowState.quantityInput.disabled = !rowState.available;
      const rowTotal = this.getPaletteModalUnitPrice(row, modal) * rowState.quantity;
      total += rowTotal;
      row.querySelector('[data-palette-row-total]').textContent = money(rowTotal);
    });
    modal.querySelector('[data-palette-modal-total]').textContent = money(total);
  }

  getPaletteModalRowState(row) {
    const select = row.querySelector('[data-palette-size]');
    const selectedOption = select.options[select.selectedIndex];
    const selectValues = select.value.split('|');
    const available = selectValues[2] === 'true';
    const quantityInput = row.querySelector('[data-palette-quantity]');
    const quantity = available ? parseInt(quantityInput.value) || 0 : 0;

    return {
      selectValues,
      selectedOption,
      quantityInput,
      quantity,
      available,
      price: parseInt(selectValues[1]) || 0,
      tierGroup: selectedOption?.dataset.tierGroup,
      tieredPricing: selectValues[4]
    };
  }

  getLineItemProperties(tieredPricing) {
    if (!tieredPricing) return {};

    try {
      JSON.parse(tieredPricing);
      return { _tiered_pricing: tieredPricing };
    } catch (error) {
      Logger.info(`${this.name} > invalid _tiered_pricing`, tieredPricing, error);
      return {};
    }
  }

  async addItemsToCartInBatches(items, batchSize = 10) {
    for (let index = 0; index < items.length; index += batchSize) {
      const batch = items.slice(index, index + batchSize);
      const resp = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: batch })
      });

      if (resp.status !== 200) return resp;
    }

    return { status: 200 };
  }

  getPaletteModalUnitPrice(row, modal) {
    const rowState = this.getPaletteModalRowState(row);
    if (!rowState.tieredPricing) return rowState.price;

    const pricing = JSON.parse(rowState.tieredPricing);
    const tierQuantity = rowState.tierGroup
      ? this.getPaletteModalTierGroupQuantity(modal, rowState.tierGroup)
      : rowState.quantity;
    const tier = tierQuantity === 0
      ? pricing[0]
      : pricing.find(t =>
        tierQuantity >= t.minQuantity &&
        (!t.maxQuantity || tierQuantity <= t.maxQuantity)
      );

    return tier ? tier.price * 100 : rowState.price;
  }

  getPaletteModalTierGroupQuantity(modal, tierGroup) {
    return Array.from(modal.querySelectorAll('.color-palette-modal__row')).reduce((total, row) => {
      const rowState = this.getPaletteModalRowState(row);
      return rowState.tierGroup === tierGroup ? total + rowState.quantity : total;
    }, 0);
  }

  async addPaletteToCart(e, modal) {
    e.preventDefault();
    const items = Array.from(modal.querySelectorAll('.color-palette-modal__row')).map(row => {
      const values = row.querySelector('[data-palette-size]').value.split('|');
      const quantity = parseInt(row.querySelector('[data-palette-quantity]').value) || 0;
      return {
        id: values[0],
        quantity,
        properties: this.getLineItemProperties(values[4])
      };
    }).filter(item => item.quantity > 0);
    if (!items.length) return;

    const submit = modal.querySelector('.color-palette-modal__submit');
    submit.disabled = true;
    const resp = await this.addItemsToCartInBatches(items);

    if (resp.status === 200) {
      StorageService.save('last-added-url', window.location.href);
      window.location.href = '/cart';
    } else {
      const json = await resp.json();
      alert(json.message);
      submit.disabled = false;
    }
  }

  syncVariantsBeforeAdd() {
    const rows = Array.from(this.querySelectorAll('li[is="color-table-item"]'));

    this.#variants = rows.map(row => {
      const select = row.querySelector('select[data-size]');
      const quantityInput = row.querySelector('input[data-quantity]');
      if (!select || !quantityInput) return null;

      const values = select.value.split('|');
      const available = values[2] === 'true';
      const quantity = available ? parseInt(quantityInput.value) || 0 : 0;
      const tieredPricing = values[4] || row.dataset.tieredPricing;
      const price = row.price || parseInt(values[1]) || 0;

      return {
        id: values[0],
        quantity,
        price: Math.floor(quantity * price),
        option: row.dataset.colorOption,
        otherOption: values[3] || row.dataset.otherOption,
        tieredPricing
      };
    }).filter(obj => obj && obj.quantity > 0);

    this.totalPrice = (this.#variants.map(obj => obj.price).reduce((prev, cur) => prev + cur, 0) / 100).toFixed(2);
  }

  clamp(value, min, max) {
    return Math.max(min, Math.min(value, Math.max(min, max)));
  }

  async #addToCart(checkout = false) {
    this.syncVariantsBeforeAdd();
    if (!this.#variants.length) return;
    //
    this.addToCartBtn.disabled = true;
    if (this.mobileAddToCartBtn) this.mobileAddToCartBtn.disabled = true;
    if (this.buyNowBtn) this.buyNowBtn.disabled = true;
    //
    const items = this.#variants.map(obj => ({
      id: obj.id,
      quantity: obj.quantity,
      properties: this.getLineItemProperties(obj.tieredPricing)
    }));
    //
    const resp = await this.addItemsToCartInBatches(items);
    //
    let now;
    if (resp.status === 200) {
      StorageService.save('last-added-url', window.location.href);
      now = Date.now();
      this.items.forEach(item => item.dataset.reset = now);
      this.addToCartBtn.disabled = false;
      if (this.mobileAddToCartBtn) this.mobileAddToCartBtn.disabled = false;
      window.location.href = checkout ? '/checkout' : '/cart';
      /* const json = await resp.json();
      console.log(json); */
    } else {
      // TODO: error handling
      const json = await resp.json();
      alert(json.message);
      now = Date.now();
      this.items.forEach(item => item.dataset.reset = now);
      this.addToCartBtn.disabled = false;
      if (this.mobileAddToCartBtn) this.mobileAddToCartBtn.disabled = false;
      if (this.buyNowBtn) this.buyNowBtn.disabled = false;
    }
  }
}

customElements.define('color-variant-picker', ColorVariantPicker);
